import { defineComponent as _defineComponent } from 'vue'
type Variant = 'default' | 'outline';
interface Props {
  icon?: string;
  closable?: boolean;
  variant?: Variant;
}

export default /*#__PURE__*/_defineComponent({
  __name: 't-chip',
  props: {
    icon: null,
    closable: { type: Boolean },
    variant: null
  },
  emits: ['close'],
  setup(__props: any) {




return { __sfc: true, }
}

})